import React from "react";
import InvoiceEditor from "@/pages/sales/InvoiceEditor";
export default function PurchaseReturns() { return <InvoiceEditor kind="purchase_return" />; }
